import React from "react";
import queryString from "query-string";
import { Search } from "history";

import { responseValidator } from "../../services/responseValidator";
import { authService } from "../../services/authService";

import { InternalError } from "../../models/internal-error.model";
import { NpuError } from "../../models/error.model";
import { JwtToken } from "../../models/token.model";
import { Role, UiMode } from "../../models/static.model";

import { config } from "../../utils/config";

import Logger from "../../utils/logger";
import {
  LOGIN_PATH,
  linkToMain,
  linkToRules,
  linkToSettings,
  linkToSearch,
} from "../Routes/var_PATHS";
import CircularSpinner from "../spinners/circular";
import { Grid } from "@material-ui/core";

type AuthProps = {
  location: Search;
};

const AuthComponent: React.FC<AuthProps> = (props: AuthProps) => {
  const logger = new Logger("AuthComponent");

  const ERROR_CODE_PARAM = "errorCode";

  const queryParams = queryString.parse(props.location);

  ((_) => {
    if (
      !queryParams.accessToken ||
      !queryParams.refreshToken ||
      !queryParams.role ||
      !queryParams.uiMode
    ) {
      const url = `${LOGIN_PATH}?${ERROR_CODE_PARAM}=${InternalError.NotFoundAuthParamsError}`;
      window.location.replace(url);
    } else {
      const refreshToken: JwtToken = queryParams.refreshToken as JwtToken;
      const sessionToken: JwtToken = queryParams.accessToken as JwtToken;
      const role: Role = responseValidator.parseRole(
        queryParams.role as string
      );
      const uiMode: UiMode = responseValidator.parseUiMode(
        queryParams.uiMode as string
      );

      if (role === Role.Unknown) {
        const url = `${LOGIN_PATH}?${ERROR_CODE_PARAM}=${InternalError.NotFoundAuthParamsError}`;
        return window.location.replace(url);
      }

      // logger.debug("role :", role);
      // logger.debug("sessionToken :", sessionToken);
      // logger.debug("refreshToken :", refreshToken);

      authService
        .login(role, sessionToken, refreshToken, uiMode)
        .then(() => {
          setTimeout(() => {
            // const url = `${LOGIN_PATH}?${ERROR_CODE_PARAM}=${InternalError.NotFoundAuthParamsError}`;

            role === Role.Admin
              ? // ? linkToMain()
                window.location.replace("/dashboard")
              : role === Role.User
              ? window.location.replace("/search")
              : // ? linkToSearch()
                window.location.replace("/account");
            // : linkToSettings();
          }, 2000);
        })
        .catch((error) => {
          if (error instanceof NpuError) {
            const { errorCode } = error as NpuError;
            const url = `${config.feBaseUrl}${LOGIN_PATH}?${ERROR_CODE_PARAM}=${errorCode}`;
            window.location.replace(url);
          } else {
            const url = `${config.feBaseUrl}${LOGIN_PATH}?${ERROR_CODE_PARAM}=${InternalError.GeneralError}&msg=${error.errorMessage}`;
            logger.error(error);
            window.location.replace(url);
            throw error;
          }
          // localStorageAsync.setItem("gbR", false);
        });
    }
  })();

  return (
    <>
      <Grid container item xs justify="center" style={{ marginTop: 320 }}>
        <CircularSpinner />
      </Grid>
    </>
  );
};

export default AuthComponent;
